module.exports = __webpack_public_path__ + "static/media/postcard10.ba2a62bd.jpg";